const mixBlendMode = {
  name: "mix-blend-mode",
  path: "mix-blend-mode",
  title: "mix-blend-mode",
  description: "Utilities for controlling the CSS mix-blend-mode property.",
  value: {
    "mix-blend-mode": {
      "mix-blend-normal": "normal",
      "mix-blend-multiply": "multiply",
      "mix-blend-screen": "screen",
      "mix-blend-overlay": "overlay",
      "mix-blend-darken": "darken",
      "mix-blend-lighten": "lighten",
      "mix-blend-color-dodge": "color-dodge",
      "mix-blend-color-burn": "color-burn",
      "mix-blend-hard-light": "hard-light",
      "mix-blend-soft-light": "soft-light",
      "mix-blend-difference": "difference",
      "mix-blend-exclusion": "exclusion",
      "mix-blend-hue": "hue",
      "mix-blend-saturation": "saturation",
      "mix-blend-color": "color",
      "mix-blend-luminosity": "luminosity",
      "mix-blend-plus-lighter": "plus-lighter",
      "mix-blend-plus-darker": "plus-darker"
    }
  },
  exampleData: [
    {
      title: "mix-blend-multiply, mix-blend-screen",
      description: "Apply different blend modes to overlapping elements:",
      example: {
        code: `<div class="flex">
    <div class="w-32 h-32 rounded-full bg-color-blue-500 mix-blend-multiply"></div>
    <div class="w-32 h-32 -ml-1/4 rounded-full bg-color-pink-500"></div>
</div>

<div class="flex">
    <div class="w-32 h-32 rounded-full bg-color-yellow-500 mix-blend-screen"></div>
    <div class="w-32 h-32 -ml-1/4 rounded-full bg-color-green-500"></div>
</div>`
      }
    }
  ],
  htmlData: [
    {
      title: "Mix blend mode",
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">mix-blend-*</code> utilities to control the blend mode of an element.
      </p>
      <div class="flex gap-8 items-center justify-center">
        <div class="flex">
          <div class="w-32 h-32 rounded-full bg-color-blue-500 mix-blend-multiply"></div>
          <div class="w-32 h-32 -ml-1/4 rounded-full bg-color-pink-500"></div>
        </div>
        <div class="flex">
          <div class="w-32 h-32 rounded-full bg-color-yellow-500 mix-blend-screen"></div>
          <div class="w-32 h-32 -ml-1/4 rounded-full bg-color-green-500"></div>
        </div>
      </div>
      `
    }
  ]
};

export default mixBlendMode;
<div class="flex gap-8 items-center sr-only  -ml-1/4">
      <div class="flex gap-8 items-center justify-center">
        <div class="flex">
          <div class="w-32 h-32 rounded-full bg-color-blue-500 mix-blend-multiply"></div>
          <div class="w-32 h-32 rounded-full bg-color-pink-500"></div>
        </div>
        <div class="flex">
          <div class="w-32 h-32 rounded-full bg-color-yellow-500 mix-blend-screen"></div>
          <div class="w-32 h-32 rounded-full bg-color-green-500"></div>
        </div>
      </div>
      </div>